import React from "react";
import OdooServices from "./OdooServices";
import HeroSection from "../common/HeroSection";
import {
  FileSearch,
  ClipboardList,
  Lightbulb,
  SlidersHorizontal,
  CircleCheckBig,
} from "lucide-react";

export default function OdooConsultation() {
  return (
    <div>
      <HeroSection
        title="Odoo Consultation & Analysis"
        breadcrumb={[
          { name: "Services", url: "/services" },
          { name: "Odoo Services", url: "/services/odoo-services" },
          {
            name: "Odoo Consultation & Analysis",
            url: "/services/odoo-services/odoo-consultation",
          },
        ]}
        background="/assets/images/about/bg.png"
      />

      <div className="bg-white">
        <div className="py-16 px-4 mx-auto container">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 px-4">
            {/* Sidebar */}
            <OdooServices />

            {/* Content */}
            <div className="lg:col-span-2">
              <div className="relative rounded-xl overflow-hidden mb-8">
                <img
                  alt="Odoo Consultation & Analysis"
                  src="/assets/images/odoo/Odoo-consulting.webp"
                  className="w-full h-auto object-cover rounded-xl"
                  loading="lazy"
                />
              </div>

              <div className="mb-8">
                <span className="text-primary font-medium text-lg inline-block py-1 font-bold rounded-full bg-primary bg-opacity-10 mb-3">
                  Strategic Planning
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Odoo <span className="text-primary">Consultation</span> &
                  Analysis
                </h2>
                <div className="prose prose-lg max-w-none text-gray-600">
                  <p>
                    Our Odoo Consultation Services help businesses maximize the
                    value of their Odoo investment. From process analysis and
                    solution design to module selection and implementation
                    strategy, we guide you in aligning Odoo with your unique
                    business needs. Our experts ensure you choose the right
                    approach, minimize risks, and achieve faster ROI.
                  </p>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  What We Offer
                </h3>
                <div className="grid grid-cols-1 gap-4">
                  <div className="p-6 rounded-xl shadow-soft border border-gray-100">
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                         Business process analysis & gap assessment
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                          Odoo module selection & roadmap planning
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                         Customization & integration strategy
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                         Performance optimization & scalability guidance
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />

                        <span className="text-gray-700">
                         Ongoing advisory & support
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our Consultation Services
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full mb-4 inline-flex items-center justify-center">
                      <FileSearch className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Business Process Analysis
                    </h4>
                    <p className="text-gray-600">
                      We evaluate your current workflows to identify
                      inefficiencies and determine how Odoo can improve
                      productivity and reduce costs.
                    </p>
                  </div>

                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full mb-4 inline-flex items-center justify-center">
                      <ClipboardList className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Requirement Gathering
                    </h4>
                    <p className="text-gray-600">
                      We work closely with stakeholders to gather detailed
                      requirements and match them with the right Odoo modules
                      and workflows.
                    </p>
                  </div>

                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full mb-4 inline-flex items-center justify-center">
                      <Lightbulb className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Feasibility Study
                    </h4>
                    <p className="text-gray-600">
                      We assess whether Odoo is the right fit for your business
                      model, providing cost estimates, timelines, and
                      implementation roadmaps.
                    </p>
                  </div>

                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full mb-4 inline-flex items-center justify-center">
                      <SlidersHorizontal className="h-6 w-6 text-primary" />
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Customization Strategy
                    </h4>
                    <p className="text-gray-600">
                      Based on analysis, we propose customizations, module
                      selections, and workflows that precisely meet your
                      business needs.
                    </p>
                  </div>
                </div>
              </div> */}

              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Benefits
                </h3>
                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <div className="grid grid-cols-1 gap-4">
                    {[
                      "Tailored Odoo solutions for your business",
                      "Reduced implementation risks",
                      "Expert-driven efficiency and growth",
                    ].map((benefit, index) => (
                      <div className="flex items-start" key={index}>
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 mt-1" />
                        <span className="text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-xl border border-blue-100">
                  <h4 className="text-2xl font-bold text-gray-800 mb-3">
                    Start Your Odoo Journey with Confidence
                  </h4>
                  <p className="text-gray-600 mb-6">
                    Let our experienced consultants analyze your business and
                    guide you toward the best Odoo solution.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      className="inline-block text-blue-700 font-bold bg-primary hover:bg-primary-dark py-3 px-6 rounded-lg transition-colors duration-300"
                      href="/contact-us/"
                    >
                      Request a Free Consultation
                    </a>
                    <a
                      className="inline-block border border-primary text-primary hover:bg-blue-700 hover:text-white py-3 px-6 rounded-lg transition-colors duration-300"
                      href="/services/odoo-services/"
                    >
                      Explore All Odoo Services
                    </a>
                  </div>
                </div>
              </div>
              {/* End content */}
            </div>
          </div>
        </div>
      </div>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  What is included in your Odoo consultation service?
                </h3>
                <p className="text-gray-600">
                  Our consultation covers in-depth business process analysis,
                  evaluation of your current IT infrastructure, gap
                  identification, module recommendations, and creation of a
                  detailed implementation roadmap tailored to your goals and
                  workflows.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How do you determine if Odoo is a good fit for our business?
                </h3>
                <p className="text-gray-600">
                  We assess your operational needs, current software ecosystem,
                  and future goals. Based on this analysis, we recommend whether
                  Odoo is a suitable ERP solution, and if so, which modules
                  align best with your business functions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How long does the consultation process take?
                </h3>
                <p className="text-gray-600">
                  The duration depends on your business size and complexity. A
                  typical consultation project takes 1–3 weeks, including
                  discovery sessions, documentation review, and delivery of a
                  custom recommendation report or roadmap.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Will you provide a report or roadmap after consultation?
                </h3>
                <p className="text-gray-600">
                  Yes. At the end of the consultation, we provide a detailed
                  report outlining our findings, key improvement areas,
                  recommended Odoo modules, and a phase-wise implementation
                  strategy.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Can you help with implementation after the consultation?
                </h3>
                <p className="text-gray-600">
                  Absolutely. Once the consultation is complete, our
                  implementation team can take over to execute the
                  roadmap—including module setup, customization, user training,
                  and ongoing support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
